module.exports = __webpack_public_path__ + "img/credits-friday-banner.dc1652a.svg";